import { createAtomObserver } from '@exodus/atoms'

const createSyncedBalancesPlugin = ({ syncedBalances, syncedBalancesAtom, port }) => {
  const syncedBalancesAtomObserver = createAtomObserver({
    port,
    atom: syncedBalancesAtom,
    event: 'syncedBalances',
  })
  syncedBalancesAtomObserver.register()

  return {
    onStart: () => {
      syncedBalancesAtomObserver.start()
      syncedBalances.load()
    },
    onLoad: () => {
      syncedBalancesAtomObserver.start()
    },
    onAssetsSynced: () => syncedBalances.observeBalances(),
    onClear: () => syncedBalancesAtom.set(undefined),
    onStop: () => {
      syncedBalancesAtomObserver.unregister()
      syncedBalances.stop()
    },
  }
}

// eslint-disable-next-line @exodus/export-default/named
export default {
  id: 'syncedBalancesPlugin',
  type: 'plugin',
  factory: createSyncedBalancesPlugin,
  dependencies: ['syncedBalances', 'syncedBalancesAtom', 'port'],
  public: true,
}
